import { useMemo } from "react";
import { useNumberSerialiser } from "./numbers";

export interface PercentSerialiserOptions {
  decimalPlaces?: number;
  defaultText?: string;
  includeSymbol?: boolean;
}

export const usePercentSerialiser = (
  defaultOptions?: PercentSerialiserOptions
) => {
  const { format: formatNumber } = useNumberSerialiser<undefined>({
    decimalPlaces: defaultOptions?.decimalPlaces ?? 1,
    default: { value: undefined, text: defaultOptions?.defaultText ?? "N/A" },
  });

  return useMemo(() => {
    const format = (
      value?: number,
      optionsOverride?: PercentSerialiserOptions
    ): string => {
      const includeSymbol =
        optionsOverride?.includeSymbol ??
        defaultOptions?.includeSymbol ??
        false;
      const text = formatNumber(typeof value === "number" ? value : undefined, {
        decimalPlaces:
          optionsOverride?.decimalPlaces ?? defaultOptions?.decimalPlaces ?? 1,
        default: {
          value: undefined,
          text:
            optionsOverride?.defaultText ??
            defaultOptions?.defaultText ??
            "N/A",
        },
      });
      return includeSymbol ? `${text}%` : text;
    };

    return { format };
  }, [formatNumber, defaultOptions]);
};
